// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"11e76ee9","693":"9fba097f","845":"a51f884a","983":"0401e521"}[chunkId] + ".chunk.js";
};